//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import {getCode} from '@/api/whk';
import Validate from  '../../utils/validate.js';
import { Toast} from 'vue-ydui/dist/lib.rem/dialog';
import axios from 'axios';
import md5 from 'js-md5';
export default {
  data() {
    return {
      styleObj: {
        height: '',
        backgroundColor:'white'
      },
      ruleForm: {
        phone: '',
        password: '',
        code:''
      },
      is_sub:false,
      content:'',
      countDownTime:60
    };
  },
  watch: {
    ruleForm:{
      handler:function(val,oldval){
        if(val.phone.length == 11 && val.password.length > 0 && val.code.length == 6 ){
            this.is_sub = true
        }else{
            this.is_sub = false
        }
      },
      deep:true//对象内部的属性监听，也叫深度监听
    },
  },
  methods: {

    toLogin(){
        if(this.ruleForm.phone == ''){
          this.content = '手机号码不能为空';
          this.showToast(this.content,1500,'error');
          return;
        }else{
          if(!Validate.isPhone(this.ruleForm.phone)){
            this.content = '手机号码格式不正确';
            this.showToast(this.content,1500,'error');
            return;
          }
        }

        if(this.ruleForm.password == ''){
          this.content = '密码不能为空';
          this.showToast(this.content,1500,'error');
          return;
        }

        if(this.ruleForm.code == ''){
          this.content = '验证码不能为空';
          this.showToast(this.content,1500,'error');
          return;
        }

        axios({
          method: "POST",
          url: 'https://ypapp.cnnb.com.cn/yongpai-user/api/login2/whk_login', //填写接口地址  全路径
          data: {
            "phone": this.ruleForm.phone, //传递相关参数
            "globalDatetime": new Date().getTime(),
            "code":this.ruleForm.code,
            "password":this.ruleForm.password,
            "sign":md5("code"+this.ruleForm.code+"globalDatetime"+new Date().getTime()+"password"+this.ruleForm.password+"phone"+this.ruleForm.phone+"vote-multi_20191018(zhejiang120102#$%)")
          },
        }).then((res) => {
          if(res.code == 0 ){
            localStorage.removeItem("userInfo");
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$router.push({ path: '/whk/productList', query: { businessesPhone: this.ruleForm.phone}});
          }else{
            this.content = res.message;
            this.showToast(this.content,1500,'error');
          }

        });

    },
    getCode(){
      if(this.ruleForm.phone == ''){
        this.content = '手机号码不能为空';
        this.showToast(this.content,1500,'error');
        return;
      }else{
        if(!Validate.isPhone(this.ruleForm.phone)){
          this.content = '手机号码格式不正确';
          this.showToast(this.content,1500,'error');
          return;
        }
      }
      localStorage.removeItem("myEndTime1");
      let endMsRes = (new Date()).getTime() + 60000;
      localStorage.setItem('myEndTime1', JSON.stringify(endMsRes));
      this.codeCountDown(endMsRes);
      this.getPhoneCode();
      /*$('#J_getCode').hide();
      $('#J_second').html('60');
      $('#J_resetCode').show();
      this.getPhoneCode();
      var second = 60;
      var timer = null;
      timer = setInterval(function(){
        second -= 1;
        if(second >0 ){
          $('#J_second').html(second);
        }else{
          clearInterval(timer);
          $('#J_getCode').show();
          $('#J_resetCode').hide();
        }
      },1000);*/
    },
    codeCountDown ( endMsRes) {
      this.countDownTime= Math.ceil((endMsRes - (new Date()).getTime()) / 1000)
      let time = setTimeout(() => {
        this.countDownTime--
        if (this.countDownTime< 1) {
          this.countDownTime= 60
          clearTimeout(time)
          $('#J_getCode').show();
          $('#J_resetCode').hide();
        } else {
          $('#J_getCode').hide();
          $('#J_resetCode').show();
          this.codeCountDown(endMsRes)
        }
      }, 1000)
    },
    showToast(content,timeout,icon){
      this.$dialog.toast({
        mes: content,
        timeout: timeout,
        icon: icon,
      });
    },
    getPhoneCode(){
      axios({
        method: "POST",
        url: 'https://ypapp.cnnb.com.cn/yongpai-service/api/sms/get_code2', //填写接口地址  全路径
        data: {
          "phone": this.ruleForm.phone, //传递相关参数
          "globalDatetime": new Date().getTime(),
          "type":1,
          "sign":md5("globalDatetime"+new Date().getTime()+"phone"+this.ruleForm.phone+"vote-multi_20191018(zhejiang120102#$%)")
        },
      }).then((res) => {
          if(res.code != 0 ){
            this.content = res.message;
            this.showToast(this.content,1500,'error');
          }

      });
    }
  },
  created () {
    let myEndTime= localStorage.getItem("myEndTime1");
    this.codeCountDown(myEndTime)
  },
  mounted () {
      this.styleObj.height = $(window).height() + 'px';

      var sign = this.$route.query.sign;
      if(sign != 1){
        var userJson = JSON.parse(localStorage.getItem("userInfo"));
        if(userJson != null || userJson != ''){
          this.$router.push({ path: '/whk/productList', query: { businessesPhone: userJson.phone}});
        }
      }
      let myInput1 = document.getElementById('input_1');
      let myInput2 = document.getElementById('input_2');
      let myInput3 = document.getElementById('input_3');

      myInput1.addEventListener('focus',handler,false);
      myInput2.addEventListener('focus',handler,false);
      myInput3.addEventListener('focus',handler,false);
      function handler(){
        this.styleObj.height = $(window).height() + 'px';
      }
  }
};



// WEBPACK FOOTER //
// ./src/pages/whk/businesses_login.vue